var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('div',{staticClass:"site-container"},[_c('page-header'),_vm._v(" "),_c('div',{class:_vm.wrapperClass},[_c('router-view',{attrs:{"name":"sidebar"}}),_vm._v(" "),_c('router-view')],1)],1),_vm._v(" "),_c('cookie-consent',{on:{"on-accept":_vm.cookieConsentAccepted}}),_vm._v(" "),_c('home-screen-drawer',{ref:"homeScreenDrawer"}),_vm._v(" "),_c('page-footer')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3cbe5ff9","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 901
// module chunks = 93